/**
 * Text rotation animation
 */

export function initTextRotator() {
    const rotatingTexts = [
        'DE VISION',
        'D\'IMPACT', 
        'D\'IDÉES',
        'DE PROJETS',
        'D\'IMAGES',
        'DE MARQUES',
        'DE SENS'
    ];
    
    const rotatingElement = document.getElementById('rotatingText');
    let currentTextIndex = 0;
    
    if (!rotatingElement) return;
    
    setInterval(() => {
        rotatingElement.style.opacity = '0';
        setTimeout(() => {
            currentTextIndex = (currentTextIndex + 1) % rotatingTexts.length;
            rotatingElement.textContent = rotatingTexts[currentTextIndex];
            rotatingElement.style.opacity = '1';
        }, 300);
    }, 3000);
}